// frame: mdYih @ ui/dogdisk-user.pen 弹框-删除确认
// 触发:`BQOCz deleteAction (XCBd9)` / `ondv5 cancelAction (NBq3m)` 复用此组件改标题
//
// 通用二次确认 dialog:title + subtitle 由 prop 传入,默认 "确认删除?"。

export type DeleteConfirmDialogProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  /** 默认 "确认删除?" */
  title?: string
  /** 默认 "删除后文件将移入回收站,30天后自动清除。" */
  subtitle?: string
  /** 主按钮文案,默认 "删除" */
  confirmText?: string
  /** 主按钮是否 loading */
  loading?: boolean
}

export function DeleteConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = '确认删除?',
  subtitle = '删除后文件将移入回收站,30天后自动清除。',
  confirmText = '删除',
  loading = false,
}: DeleteConfirmDialogProps) {
  if (!open) return null

  return (
    <div
      data-frame-id="mdYih"
      data-testid="mdYih"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      className="fixed inset-0 z-50 flex items-end bg-black/50"
      onClick={onClose}
    >
      <div
        className="mx-auto w-full max-w-[402px] rounded-t-3xl bg-white"
        style={{ paddingBottom: 'max(34px, env(safe-area-inset-bottom))' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-center pt-2 pb-3">
          <span className="h-1 w-10 rounded-full bg-[#E0E0E0]" />
        </div>
        <header className="px-6 py-2 text-center">
          <h2 data-testid="mdYih-title" className="text-[16px] font-semibold text-[#1A1A1A]">
            {title}
          </h2>
          <p data-testid="mdYih-subtitle" className="mt-2 text-[13px] text-[#6B7280]">
            {subtitle}
          </p>
        </header>
        <div className="flex gap-2 px-6 pt-4 pb-3">
          <button
            type="button"
            data-testid="mdYih-cancel"
            onClick={onClose}
            disabled={loading}
            className="h-11 flex-1 rounded-lg bg-[#F1F2F4] text-[14px] font-semibold text-[#1A1A1A] disabled:opacity-50"
          >
            取消
          </button>
          <button
            type="button"
            data-testid="mdYih-confirm"
            onClick={onConfirm}
            disabled={loading}
            className="h-11 flex-1 rounded-lg bg-[#FF6B6B] text-[14px] font-semibold text-white active:bg-[#E55353] disabled:opacity-50"
          >
            {loading ? '处理中…' : confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}
